import React, { useState } from 'react';

function DividendEstimator() {
  const [price, setPrice] = useState('');
  const [yieldPercent, setYieldPercent] = useState('');
  const [shares, setShares] = useState('');
  const [income, setIncome] = useState(null);

  const estimate = () => {
    const p = parseFloat(price);
    const y = parseFloat(yieldPercent);
    const s = parseFloat(shares);

    if (!p || !y || !s) return;

    const annual = (p * y / 100) * s;
    const monthly = annual / 12;
    setIncome({ annual: annual.toFixed(2), monthly: monthly.toFixed(2) });
  };

  return (
    <div className="card">
      <h3>Dividend Estimator</h3>
      <input type="number" placeholder="Share Price" value={price} onChange={e => setPrice(e.target.value)} />
      <input type="number" placeholder="Yield (%)" value={yieldPercent} onChange={e => setYieldPercent(e.target.value)} />
      <input type="number" placeholder="Shares Owned" value={shares} onChange={e => setShares(e.target.value)} />
      <button onClick={estimate}>Estimate</button>
      {income && <p>Monthly: ${income.monthly}<br />Annual: ${income.annual}</p>}
    </div>
  );
}

export default DividendEstimator;
